import { iApi } from '@/Engine/apiInterfaces';
import { update } from 'lodash';


export const testJSON = {
    data: {
        configurator: {
            action: 'update',
            payLoad: {
                data: {
                    lockers: [
                        {
                            'type': 'locker',
                            'sort': 1,
                            'bottom': [
                                {
                                    'type': 'bottom',
                                    'bottomType': 'bench',
                                    'externalId': '55553',
                                    'blender_name': 'bench500',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                },
                            ],
                            'top': [
                                {
                                    'type': 'bottom',
                                    'externalId': '66663',
                                    'blender_name': 'ml_41_50',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'original': {
                                        'id': '8127',
                                        'code': '',
                                        'name': 'Крыша наклонная ML 500',
                                        'article': '',
                                        'externalId': '66663',
                                        'blender_name': 'ml_41_50',
                                        'scale': '',
                                        'offsets': null,
                                        'rotation': '',
                                        'width': '500',
                                        'compatibleSections': false,
                                        'price': 0,
                                        'currency': '',
                                        'topType': 'incline',
                                    },
                                },
                            ],
                            'body_color': '#ebedee',
                            'door_color': '#ebedee',
                            'show_doors': false,
                            'sections': [
                                {
                                    'type': 'head_section',
                                    'sort': 1,
                                    'externalId': '37634',
                                    'blender_name': 'ml_11_50_d',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'displayType': 'shelf/rail/shelf/wall',
                                    'name': 'Шкаф для раздевалок усиленный ML-11-50 базовый модуль',
                                    'content': [],
                                },
                            ],
                        },
                        {
                            'type': 'locker',
                            'sort': 1,
                            'bottom': [
                                {
                                    'type': 'bottom',
                                    'bottomType': 'bench',
                                    'externalId': '55551',
                                    'blender_name': 'bench300',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                },
                                {
                                    'type': 'bottom',
                                    'bottomType': 'bench',
                                    'externalId': '55551',
                                    'blender_name': 'bench300',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                },
                                {
                                    'type': 'bottom',
                                    'bottomType': 'bench',
                                    'externalId': '55552',
                                    'blender_name': 'bench400',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                },
                            ],
                            'top': [],
                            'body_color': '#babcbf',
                            'door_color': '#babcbf',
                            'show_doors': true,
                            'sections': [
                                {
                                    'type': 'head_section',
                                    'sort': 1,
                                    'externalId': '10828',
                                    'blender_name': 'ml_11_50_d',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'displayType': 'shelf/rail/shelf',
                                    'name': 'Шкаф для раздевалок усиленный ML-11-30 (LS-01)',
                                    'content': [
                                        // {
                                        //     'type': 'shelf',
                                        //     'externalId': '37697',
                                        //     'blender_name': 'polka_300',
                                        //     'scale': '',
                                        //     'offsets': null,
                                        //     'rotation': '',
                                        // },
                                    ],
                                },
                                {
                                    'type': 'additional_section',
                                    'sort': 2,
                                    'externalId': '12103',
                                    'blender_name': 'ml_01_30_u',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'displayType': 'shelf/rail',
                                    'name': 'Шкаф для раздевалок усиленный ML-01-30 (LS-001) доп модуль',
                                    'content': [],
                                },
                                {
                                    'type': 'head_section',
                                    'sort': 3,
                                    'externalId': '45668',
                                    'blender_name': 'ml_14_40',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'displayType': '',
                                    'name': 'Шкаф для раздевалок усиленный ML-14-40 базовый модуль',
                                    'content': [],
                                },
                            ],
                        },
                        {
                            'type': 'locker',
                            'sort': 2,
                            'bottom': [
                                {
                                    'type': 'bottom',
                                    'bottomType': 'headLegs',
                                    'externalId': '37397',
                                    'blender_name': 'ml_300',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                },
                                {
                                    'type': 'bottom',
                                    'bottomType': 'headLegs',
                                    'externalId': '37397',
                                    'blender_name': 'ml_300',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                },
                                {
                                    'type': 'bottom',
                                    'bottomType': 'additionalLegs',
                                    'externalId': '37398',
                                    'blender_name': 'ml_300_dop',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                },
                            ],
                            'top': [],
                            'body_color': '#da0000',
                            'door_color': '#da0000',
                            'show_doors': false,
                            'sections': [
                                {
                                    'type': 'head_section',
                                    'sort': 1,
                                    'externalId': '37391',
                                    'blender_name': 'ml_12_30',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'displayType': 'rail',
                                    'name': 'Шкаф для раздевалок усиленный ML-12-30 (LS-02) базовый модуль',
                                    'content': [],
                                },
                                {
                                    'type': 'head_section',
                                    'sort': 2,
                                    'externalId': '10828',
                                    'blender_name': 'ml_11_30',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'displayType': 'shelf/rail/shelf',
                                    'name': 'Шкаф для раздевалок усиленный ML-11-30 (LS-01)',
                                    'content': [
                                        {
                                            'type': 'shelf',
                                            'externalId': '37697',
                                            'blender_name': 'polka_300',
                                            'scale': '',
                                            'offsets': null,
                                            'rotation': '',
                                        },
                                    ],
                                },
                                {
                                    'type': 'additional_section',
                                    'sort': 3,
                                    'externalId': '12103',
                                    'blender_name': 'ml_01_30_u',
                                    'scale': '',
                                    'offsets': null,
                                    'rotation': '',
                                    'displayType': 'shelf/rail',
                                    'name': 'Шкаф для раздевалок усиленный ML-01-30 (LS-001) доп модуль',
                                    'content': [],
                                },
                            ],
                        },
                    ],
                },
            },
        },
    },

};

export const testJSON2 = {
    data: {
        configurator: {
            action: 'update',
            payLoad: {
                data: {
                    lockers: [
                        {
                            type: 'locker',
                            sort: 1,
                            bottom: [
                                {
                                    type: 'bottom',
                                    bottomType: 'benchPullout',
                                    externalId: '38757',
                                    blender_name: 'ML_21_30',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                },
                            ],
                            top: [],
                            body_color: '#d9d9d9',
                            door_color: '#d9d9d9',
                            show_doors: false,
                            sections: [
                                {
                                    type: 'head_section',
                                    sort: 1,
                                    externalId: '10828',
                                    blender_name: 'ml_11_30',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-11-30 (LS-01)',
                                    content: [],
                                },
                            ],
                        },
                        {
                            type: 'locker',
                            sort: 1,
                            bottom: [
                                {
                                    type: 'bottom',
                                    bottomType: 'benchPullout',
                                    externalId: '38758',
                                    blender_name: 'ML_21_40',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                },
                            ],
                            top: [],
                            body_color: '#d9d9d9',
                            door_color: '#d9d9d9',
                            show_doors: false,
                            sections: [
                                {
                                    type: 'head_section',
                                    sort: 1,
                                    externalId: '37635',
                                    blender_name: 'ml_11_40',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-11-40 базовый модуль',
                                    content: [],
                                },
                            ],
                        },
                        {
                            type: 'locker',
                            sort: 1,
                            bottom: [
                                {
                                    type: 'bottom',
                                    bottomType: 'benchPullout',
                                    externalId: '38759',
                                    blender_name: 'ML_21_50',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                },
                            ],
                            top: [],
                            body_color: '#d9d9d9',
                            door_color: '#d9d9d9',
                            show_doors: false,
                            sections: [
                                {
                                    type: 'head_section',
                                    sort: 1,
                                    externalId: '37634',
                                    blender_name: 'ml_11_50_d',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail/shelf/wall',
                                    name: 'Шкаф для раздевалок усиленный ML-11-50 базовый модуль',
                                    content: [],
                                },
                            ],
                        },
                        {
                            type: 'locker',
                            sort: 1,
                            bottom: [
                                {
                                    type: 'bottom',
                                    bottomType: 'benchPullout',
                                    externalId: '38760',
                                    blender_name: 'ML_21_60',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                },
                            ],
                            top: [],
                            body_color: '#d9d9d9',
                            door_color: '#d9d9d9',
                            show_doors: false,
                            sections: [
                                {
                                    type: 'head_section',
                                    sort: 1,
                                    externalId: '10828',
                                    blender_name: 'ml_11_30',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-11-30 (LS-01)',
                                    content: [],
                                },
                                {
                                    type: 'additional_section',
                                    sort: 2,
                                    externalId: '12103',
                                    blender_name: 'ml_01_30_u',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-01-30 (LS-001) доп модуль',
                                    content: [],
                                },
                            ],
                        },
                        {
                            type: 'locker',
                            sort: 1,
                            bottom: [
                                {
                                    type: 'bottom',
                                    bottomType: 'benchPullout',
                                    externalId: '38761',
                                    blender_name: 'ML_21_80',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                },
                            ],
                            top: [],
                            body_color: '#d9d9d9',
                            door_color: '#d9d9d9',
                            show_doors: false,
                            sections: [
                                {
                                    type: 'head_section',
                                    sort: 1,
                                    externalId: '37635',
                                    blender_name: 'ml_11_40',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-11-40 базовый модуль',
                                    content: [],
                                },
                                {
                                    type: 'additional_section',
                                    sort: 2,
                                    externalId: '37511',
                                    blender_name: 'ml_01_40_u',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-01-40 (LS-001-40) доп модуль',
                                    content: [],
                                },
                            ],
                        },
                        {
                            type: 'locker',
                            sort: 1,
                            bottom: [
                                {
                                    type: 'bottom',
                                    bottomType: 'benchPullout',
                                    externalId: '38762',
                                    blender_name: 'LS_ML_21_60',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                },
                            ],
                            top: [],
                            body_color: '#d9d9d9',
                            door_color: '#d9d9d9',
                            show_doors: false,
                            sections: [
                                {
                                    type: 'head_section',
                                    sort: 1,
                                    externalId: '10828',
                                    blender_name: 'ml_11_30',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-11-30 (LS-01)',
                                    content: [],
                                },
                                {
                                    type: 'additional_section',
                                    sort: 2,
                                    externalId: '12103',
                                    blender_name: 'ml_01_30_u',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-01-30 (LS-001) доп модуль',
                                    content: [],
                                },
                            ],
                        },
                        {
                            type: 'locker',
                            sort: 1,
                            bottom: [
                                {
                                    type: 'bottom',
                                    bottomType: 'benchPullout',
                                    externalId: '38763',
                                    blender_name: 'LS_ML_21_80',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                },
                            ],
                            top: [],
                            body_color: '#d9d9d9',
                            door_color: '#d9d9d9',
                            show_doors: false,
                            sections: [
                                {
                                    type: 'head_section',
                                    sort: 1,
                                    externalId: '37635',
                                    blender_name: 'ml_11_40',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-11-40 базовый модуль',
                                    content: [],
                                },
                                {
                                    type: 'additional_section',
                                    sort: 2,
                                    externalId: '37511',
                                    blender_name: 'ml_01_40_u',
                                    scale: '',
                                    offsets: null,
                                    rotation: '',
                                    displayType: 'shelf/rail',
                                    name: 'Шкаф для раздевалок усиленный ML-01-40 (LS-001-40) доп модуль',
                                    content: [],
                                },
                            ],
                        },
                    ],
                },
            },
        },
    },
};
